<script>

import functions from '../../mixins/import/handle_duplicates.js';

export default {
	data() {
		return {
			path: '/import-gift-cards/'
		}
	},
	mixins: [functions],
	methods: {
		async onConfirm(e) {

			this.isLoading = true;

			await axios.post(this.path + this.id + '/handle-duplicate', {
				rows: this.duplicateRows,
				duplicated_by: this.duplicatedBy,
				duplicated_value: this.duplicatedValue,
				skip_duplicate_check: this.doSkipDuplicateCheck
			}).then(response => {

				this.loadDuplicates();

			}).catch(error => {

				if (error && error.response.status === 422 && error.response.data.errors) {
					this.errors = error.response.data.errors || {};
				}

				flash('Handling failed, please check the form data!', 'danger');

			});

			this.isLoading = false;
			this.doSkipDuplicateCheck = false;

		},
		async loadDuplicates() {

			await axios.get(this.path + this.id + '/get-duplicate').then(response => {

				if (response.data.duplicates.total_rows > 0) {
					this.setRow(response.data);

				} else {
					window.location = '/import/' + this.id +  '/summary';
				}

			}).catch(error => {

				if (error && error.response.status === 422 && error.response.data.errors) {
					this.errors = error.response.data.errors || {};
				}

			});

		},
		fieldsIdentical(rows, field) {

			let values = [];

			for (let j = 0; j < rows.length; j++) {

				if (field === 'name') {
					values.push(rows[j].name);
				} else if (field === 'unit') {
					values.push(rows[j].unit);
				} else if (field === 'selling_price') {
					values.push(rows[j].selling_price);
				} else if (field === 'inventory_tracking') {
					values.push(rows[j].inventory_tracking);
				} else if (field === 'purchase_price') {
					values.push(rows[j].purchase_price);
				} else if (field === 'quantity') {
					values.push(rows[j].quantity);
				} else if (field === 'sku') {
					values.push(rows[j].sku);
				}


			}

			return (_.uniq(values).length === 1);
		}
	}
}

</script>